export default __webpack_public_path__ + "static/media/icon-mute-intro.3b189359.svg";